/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetUploadLogsProps,
  IGetTrackerEventProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "ProvisionalPageService";
const log: any = LoggerModule.getInstance();

export type IUploadLogsPageSrvGetPageContentArgs =
  IGetUploadLogsProps & IGetTrackerEventProps;

export class UploadLogsPageService {
  private static instance: UploadLogsPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): UploadLogsPageService {
    if (!UploadLogsPageService.instance) {
      UploadLogsPageService.instance = new UploadLogsPageService(props);
    }
    return UploadLogsPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(
    args: IUploadLogsPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUploadLogsProps({
      ...args,
      where: [...args?.where, ...this.criteria],
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getUploadLogs(args:any){
    const agent = getAgent();
    return agent.getUploadLogsProps(args);
  }

  public getDownloadTrackerEvent(args:any){
    const agent = getAgent();
    return agent.getDownloadTrackerEventProps(args);
  }
}
